class CartModalQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.valueSpan = this.querySelector('span.cart-modal__quantity-label');
    this.input = this.querySelector('input.cart-modal__quantity-input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    let newValue = parseInt(this.valueSpan.innerHTML);
    if (event.target.name === 'plus') {
      newValue++;
    } else {
      newValue = Math.max(0, newValue - 1);
    }
    if (parseInt(this.input.value) !== newValue) {
      this.input.value = newValue;
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define('cart-modal-quantity-input', CartModalQuantityInput);

class CartModalItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('CartModal-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0,
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-header-button',
        section: 'cart-header-button',
        selector: '#shopify-section-cart-header-button',
      },
      {
        id: 'cart-modal-cart-items',
        section: 'cart-modal-product-list',
        selector: '.js-contents',
      },
      {
        id: 'cart-modal-total',
        section: 'cart-modal-total',
        selector: '#shopify-section-cart-modal-total',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartModalWrapper = document.querySelector('cart-modal-items');

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);

        if (document.getElementById('cart-modal-top-counter')) {
          document.getElementById('cart-modal-top-counter').innerText = parsedState.item_count + ' products';
        }

        const lineItem = document.getElementById(`CartModal-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          if (cartModalWrapper) trapFocus(cartModalWrapper, lineItem.querySelector(`[name="${name}"]`));
          else lineItem.querySelector(`[name="${name}"]`).focus();
        } else {
          trapFocus(cartModalWrapper, cartModalWrapper.querySelector('#CartModal-CartItems'));
        }
        this.disableLoading();
      })
      .catch(() => {
        const errors = document.getElementById('CartModal-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    const quantityOuputElement = document.getElementById(`CartModal-ItemQuantity-${line}`);
    if (quantityOuputElement) {
      const quantityValue = parseInt(quantityOuputElement.innerHTML);

      if (this.currentItemCount === itemCount) {
        const lineItemError = document.getElementById(`CartModal-LineItemError-${line}`);
        lineItemError.querySelector('.cart-modal__error-text').innerHTML = window.cartStrings.quantityError.replace('[quantity]', quantityValue);
      } else {
        const quantityInputElement = document.getElementById(`CartModal-ItemQuantityInput-${line}`);
        quantityOuputElement.innerHTML = quantityInputElement.value;
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('CartModal-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const modalCartSections = document.querySelectorAll('#cart-modal-product-list, .cart-modal__bottom-container');
    modalCartSections.forEach((section) => section.classList.add('cart-modal__items--disabled'));

    const lineItemError = document.getElementById(`CartModal-LineItemError-${line}`);
    lineItemError.querySelector('.cart-modal__error-text').innerHTML = '';

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const modalCartSections = document.querySelectorAll('#cart-modal-product-list, .cart-modal__bottom-container');
    modalCartSections.forEach((section) => section.classList.remove('cart-modal__items--disabled'));
  }
}

customElements.define('cart-modal-items', CartModalItems);
